
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return_loss",
      function () {
        return require("private-next-pages/return_loss.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return_loss"])
      });
    }
  